import {HttpErrorResponse, HttpRequest} from '@angular/common/http'
import {inject, Injectable} from '@angular/core'
import {MatDialog} from '@angular/material/dialog'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'

import {ErrorDialogComponent} from './error-dialog.component'

@Injectable({
  providedIn: 'root'
})
export class ResponseErrorHelperService {
  private configService = inject(ConfigService)
  private dialog = inject(MatDialog)

  private errorMessage = 'Ett fel har tyvärr uppstått##ERROR##. Prova ladda om sidan och om felet ' +
    'kvarstår bör du inte fortsätta rådgivningen då fel värden kan visas. ' +
    'Kontakta Ulrika Plato och meddela vilken kund och rådgivning felet har uppstått i.'

  public handleError(req: HttpRequest<any>, error: HttpErrorResponse) {
    if (error.status === 401 || error.status === 403) {
      this.configService.reset()
      return
    }

    if (req.url.includes('accounts')) {
      this.errorMessage = this.errorMessage.replace('##ERROR##', ' hos AbaSec')
    }

    if (req.url.includes('ms-xray-portfolio') || req.url.includes('ms-portfolio-summary')) {
      this.errorMessage = this.errorMessage.replace('##ERROR##', ' hos Morningstar')
    }

    if (req.url.includes('documents')) {
      const errorMessage = 'Kundens ##ERROR## verkar vara fel. Kontrollera och prova igen.'
      if (error.error.errorMessage.includes('email')) {
        this.errorMessage = errorMessage.replace('##ERROR##', 'epost')
      }
      if (error.error.errorMessage.includes('phone')) {
        this.errorMessage = errorMessage.replace('##ERROR##', 'mobilnummer')
      }
    } else {
      this.errorMessage = this.errorMessage.replace('##ERROR##', '')
    }

    this.dialog.open(ErrorDialogComponent, {
      data: {
        text: this.errorMessage
      },
      disableClose: true
    })
  }
}
